import { create } from 'zustand';

export type ModalAlertVariant = 'danger' | 'warning' | 'info';

type ModalAlertItem = {
    id: string;
    message: string;
    subMessage?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onAlert: () => void;
    onCancel?: () => void;
    variant?: ModalAlertVariant;
};

type ModalAlertStore = {
    isOpen: boolean;
    currentAlert: ModalAlertItem | null;
    openModalAlert: (item: ModalAlertItem) => void;
    closeModalAlert: () => void;
};

export const useModalAlertStore = create<ModalAlertStore>((set) => ({
    isOpen: false,
    currentAlert: null,

    openModalAlert: (item) => set({ isOpen: true, currentAlert: item }),

    closeModalAlert: () => set({ isOpen: false, currentAlert: null }),
}));
